<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
  <button data-ci="btnPaymentCard" mat-button color="blue" (click)="updatePayment('card')">
    {{ 'enterprise_info.update_payment_method.content.credit_card' | translate }}
  </button>
  <button data-ci="btnPaymentSepa" mat-button color="blue" (click)="updatePayment('sepa')">
    {{ 'enterprise_info.update_payment_method.content.sepa' | translate }}
  </button>
</div>
